// extracted by mini-css-extract-plugin
export var legendIndicator = "_bk-1";
export var legendRight = "_bk-0";